var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-message-template-components-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendi"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v("Event")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Kanal ID")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Şablon Adı")]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_name"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Şablon ID")]),
          _vm._v(
            ": " +
              _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_id"))
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Dil")]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(_vm.activity, "payload.message_template_language")
              )
          ),
        ]),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_title")
          ? _c("div", [
              _c("b", [_vm._v("Başlık")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_title")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_element")
          ? _c("div", [
              _c("b", [_vm._v("İçerik")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_element")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.activity, "payload.message_template_footer")
          ? _c("div", [
              _c("b", [_vm._v("Footer")]),
              _vm._v(
                ": " +
                  _vm._s(
                    _vm.$_.get(_vm.activity, "payload.message_template_footer")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.templateButtons.length > 0
          ? _c("div", [
              _c("b", [_vm._v("Butonlar")]),
              _vm._v(":\n            "),
              _c(
                "ul",
                { staticClass: "buttons-list" },
                _vm._l(_vm.templateButtons, function (btn, idx) {
                  return _c("li", { key: idx }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(btn.message_template_button_text) +
                        " (" +
                        _vm._s(btn.message_template_button_type) +
                        ")\n                "
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v("Ham payload")]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }